import {ReactNode} from 'react';
import {
  DocumentCreationActionsContext,
  DocumentCreationActionsContextValue,
} from '@/components/new-document-creation/dialog/context/document-create-actions.context';

interface DocumentCreationActionsProviderProps {
  children: ReactNode;
  value: DocumentCreationActionsContextValue;
}

export const DocumentCreationActionsProvider = ({children, value}: DocumentCreationActionsProviderProps) => (
  <DocumentCreationActionsContext.Provider value={value}>{children}</DocumentCreationActionsContext.Provider>
);
